import React, {useLayoutEffect, useMemo, useState} from 'react';
import {Platform, StyleSheet, View} from 'react-native';
import {useDispatch, useSelector} from 'react-redux';
import {LoginLayout} from '../login/components/layout';
import {esiaCodeSelector} from '../../redux/selectors/login';
import {DeviceSize, useDeviceSize} from '../../shared/theme/helpers';
import {useStyles} from '../../shared/hooks/styles';
import {useIsSmallScreenDevice} from '../../shared/hooks/useIsSmallScreenDevice';
import {profileAuthenticationStateSelector} from '../../redux/selectors/profile';
import {useNavigation} from '@react-navigation/native';
import {Text} from '../../shared/components/text';
import {Checkbox} from '../../shared/components/baseField/components/checkbox/checkbox';
import {Button} from '../../shared/components/button';
import {Screens} from '../../shared/routing';

type PropTypes = {
  onSubmitHandle: (isEmail: boolean, isSms: boolean) => void;
  isSuccess: boolean;
};
export default ({onSubmitHandle, isSuccess}: PropTypes) => {
  const isAuthenticated = useSelector(profileAuthenticationStateSelector());
  const navigation = useNavigation();
  const [isSms, setIsSmsAccepted] = useState(false);
  const onSmsToggle = () => setIsSmsAccepted((prev) => !prev);

  const [isEmail, setIsEmailAccepted] = useState(false);
  const onEmailToggle = () => setIsEmailAccepted((prev) => !prev);

  const styles = useStyles(({mediaOnly, theme}) => ({
    subContainer: {
      justifyContent: 'center',
      alignItems: 'center',
      paddingHorizontal: 10,
      marginTop: 40,
    },
    checkboxContainer: {
      marginBottom: 16,
      ...mediaOnly(DeviceSize.desktop, {width: '100%'}),
      ...mediaOnly(DeviceSize.tablet, {width: '100%'}),
      ...mediaOnly(DeviceSize.mobile, {width: 260}),
      flexDirection: 'row',
      flexWrap: 'nowrap',
    },
    checkboxBtn: {
      marginRight: 12,
    },
    text: {
      flex: 1,
      ...mediaOnly(DeviceSize.desktop, theme.fonts.body, {...theme.fonts.body, lineHeight: 24}),
    },
    successText: {
      flex: 1,
      textAlign: 'center',
      ...mediaOnly(DeviceSize.desktop, theme.fonts.h4, {...theme.fonts.h4Light, lineHeight: 24}),
    },
    button: {
      width: '100%',
      ...mediaOnly(DeviceSize.desktop, {marginTop: 80}, {marginTop: 60}),
    },
    backButton: {
      width: '100%',
    },
  }));

  const handleOnBack = () => {
    if (isAuthenticated) navigation.navigate(Screens.Main);
    else navigation.navigate(Screens.Login);
  };

  const successMessage = useMemo(() => {
    let _successMessage = 'Вы успешно отписались от рассылок по ';
    const unsubscribeArray = [];
    if (isSms) unsubscribeArray.push('SMS');
    if (isEmail) unsubscribeArray.push('эл. почте');
    _successMessage += unsubscribeArray.join(' и ');
    return _successMessage;
  }, [isSms, isEmail]);

  return (
    <LoginLayout
      useBackButton={false}
      title={'Управление рассылкой'}
      showHelpText={false}
      showLogo={true}
      showTitle={true}>
      <View style={styles.subContainer}>
        {isSuccess && (
          <>
            <Text style={styles.successText}>{successMessage}</Text>
            <Button
              style={[styles.backButton, {marginTop: 110}]}
              onPress={handleOnBack}
              text='Вернуться назад'
              type='secondary'
              id='unsubscribe-submit-btn'
            />
          </>
        )}
        {!isSuccess && (
          <>
            <View style={styles.checkboxContainer}>
              <Checkbox
                style={styles.checkboxBtn}
                value={isEmail}
                onChange={onEmailToggle}
                testIDprefix='unsubscribe-checkbox-email'
              />
              <Text style={styles.text}>Отписаться от рассылки по эл. почте</Text>
            </View>
            <View style={styles.checkboxContainer}>
              <Checkbox
                style={styles.checkboxBtn}
                value={isSms}
                onChange={onSmsToggle}
                testIDprefix='unsubscribe-checkbox-sms'
              />
              <Text style={styles.text}>Отписаться от рассылки по SMS</Text>
            </View>
            <Button
              style={styles.button}
              onPress={() => onSubmitHandle(isEmail, isSms)}
              disabled={!isEmail && !isSms}
              text='Отписаться'
              id='unsubscribe-submit-btn'
            />
            <Button
              style={styles.backButton}
              onPress={handleOnBack}
              text='Вернуться назад'
              type='secondary'
              id='unsubscribe-submit-btn'
            />
            <Text type='additionalText' color='#888' style={{textAlign: 'center'}}>
              Выберите хотя бы одну рассылку для отписки
            </Text>
          </>
        )}
      </View>
    </LoginLayout>
  );
};
